// Replace with your Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyBu-SNUjirfebONBTXIB0tGCkXc6TFwbaE",
  authDomain: "moses-e7028.firebaseapp.com",
  databaseURL: "https://moses-e7028-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "moses-e7028",
  storageBucket: "moses-e7028.appspot.com",
  messagingSenderId: "808611634978",
  appId: "1:808611634978:web:47f86a007f9f73022a8f7b",
  measurementId: "G-PSQK0GEE57"
};


  export const firebaseConfigSandbox = {
    apiKey: "AIzaSyDZSX4W_uaqJ0QRUeyHg4fc_bEaQ04PM0o",
    authDomain: "moses-sandbox.firebaseapp.com",
    databaseURL: "https://moses-sandbox-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "moses-sandbox",
    storageBucket: "moses-sandbox.appspot.com",
    messagingSenderId: "147402642406",
    appId: "1:147402642406:web:09c997e37d18894ed7bc27",
    measurementId: "G-HF6BSM8XPV"
  };
